import {connect} from 'react-redux';
import Filters from 'src/components/college-search/filters/filters';
import {resetPage, getColleges} from 'src/redux/college-search/actions';

const mapDispatchToProps = (dispatch) => ({
  getColleges() {
    dispatch(resetPage());
    dispatch(getColleges());
  },
});

export default connect(null, mapDispatchToProps)(Filters);
